import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from "react-router-dom";
import Api from '../api/api';
import LoadingBar from 'react-top-loading-bar';



class BlogSinglePage extends React.Component {

    state={
        data:'',
        ref:React.createRef(null)
    }

    getProjectId = () => {
        const {id} = this.props.match.params;
        return id;
    }

    componentDidMount(){
        document.title ="Blog / Cerafini";
        document.getElementById("fav-icon").href = process.env.PUBLIC_URL + "/CERAFINI_Blog.png";
        const {ref} = this.state;
        ref.current.continuousStart(10);

        const id = this.getProjectId();

        Api.getblogSinglePage(id).then((response)=>{
            this.setState({data:response.data.blog});
            ref.current.complete();
        })
    }

    createMarkup = (data) => {
        return {__html: data};
    }

    render (){
        const {data} = this.state;
        const {langTxt}=this.props;
        return(
            <>
                <LoadingBar color='#000' height={4} ref={this.state.ref} />

            <div className="blog-single-page page">
            {(data)? 
                <>
                    <p>{data.published_at}</p>
                    <h1>{data["title_" + langTxt]}</h1>
                    <img src={data.cover_image} alt="" />
                    <span dangerouslySetInnerHTML= {this.createMarkup(data["body_" + langTxt])} />
                </>
                : <></>}
                
            </div>
            </>
        );
    }
}


// what props do i need to get from the state for this component?
const mapStateToProps = (state) => {
    // get the props needed for this component from the state of the store.
    return {
        langTxt: (state.lang && state.lang.text) || 'en',
        langUrl: (state.lang && state.lang.url) || '',
    }
}

// what events will occur that will change the state in this component
const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter( connect(mapStateToProps, mapDispatchToProps)(BlogSinglePage) );

